import FeedbackButton from "components/FeedbackButton";
import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import Box from "ds/components/Box";

const FEEDBACK_BUTTON_ID = "flows-projects--feedback-button";

const FlowsProjectsViewHeader = () => (
  <ViewHeader firstLevel>
    <Box fullWidth justify="between" align="center" gap="large">
      <ViewHeaderTitle>Flows</ViewHeaderTitle>

      <ViewHeaderWrapper direction="row" align="center" shrink="0">
        <FeedbackButton id={FEEDBACK_BUTTON_ID} />
      </ViewHeaderWrapper>
    </Box>
  </ViewHeader>
);

export default FlowsProjectsViewHeader;
